<script>
  import firebase from "firebase/compat/app";
  import { firebaseUI } from "./scripts/firebase.js";
  import "firebaseui/dist/firebaseui.css";
  import { tick } from "svelte";
  import { pageToLoad, flowData, user } from "./scripts/stores.js";

  let nextPage = "authenticate";

  let loading = true;

  console.log("login page");

  const uiConfig = {
    callbacks: {
      signInSuccessWithAuthResult: function (authResult, redirectUrl) {
        pageToLoad.set(nextPage);
        return false;
      },
      uiShown: function () {
        loading = false;
      },
    },
    // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
    signInFlow: "popup",
    signInSuccessUrl: "<url-to-redirect-to-on-success>",
    signInOptions: [
      // Leave the lines as is for the providers you want to offer your users.
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      // firebase.auth.GithubAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      // firebase.auth.PhoneAuthProvider.PROVIDER_ID
    ],
    // Terms of service url.
    tosUrl: "https://www.inside.synthase.cc/terms-of-service/",
    // Privacy policy url.
    privacyPolicyUrl: "https://www.synthase.cc/privacy-policy/",
  };

  const loadUI = async () => {
    await tick();
    firebaseUI.start("#firebaseui-auth-container", uiConfig);
  };

  loadUI();
</script>

<main>
  <div id="firebaseui-auth-container" />
  {#if loading}
    <div id="loader">Loading...</div>
  {/if}
</main>

<style>
</style>
